module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_1@2x.0544aafb.png";